import { render, staticRenderFns } from "./matchingAdmin.vue?vue&type=template&id=f7a1c73c&scoped=true"
import script from "./matchingAdmin.vue?vue&type=script&lang=js"
export * from "./matchingAdmin.vue?vue&type=script&lang=js"
import style0 from "./matchingAdmin.vue?vue&type=style&index=0&id=f7a1c73c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a1c73c",
  null
  
)

export default component.exports